import { TInquiryStatus } from '@interfaces/inquiries';

import useInquiryStatuses from './useInquiryStatuses';

const useInquiryStatusById = (statusId?: TInquiryStatus) => {
  const inquiryStatuses = useInquiryStatuses();
  return inquiryStatuses.find(status => status.id === statusId);
};

export default useInquiryStatusById;
